
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel';

let carousel;

const DOT_SIZE = 14;
const DOT_SPACING = 8;

const DOTS_VISIBLE = 5;
const DEFAULT_OFFSET = 2;

const initCurrentSlide = () => {
  let currentSlide = 0;

  return {
    get() {
      return currentSlide;
    },
    set(num) {
      currentSlide = num;
    }
  }
}

const moveDots = (count, direction, wrapper) => {
  const $dotsContianer = $(wrapper).find('.custom-dots__inner');
  const currentTranslate = $dotsContianer.css('transform').replace(/[^0-9\-.,]/g, '').split(',')[4];
  let px = ((DOT_SIZE + DOT_SPACING) * count);
  const val = direction ? Number(currentTranslate) - px : Number(currentTranslate) + px;
  $dotsContianer.css('transform', 'translateX(' + val + 'px)');
};

const resizeDots = ($prevDots, $nextDots) => {
  let prevScale = 1; let nextScale = 1;

  $prevDots.each((_, elem) => {
    if (prevScale - .15 > 0) {
      prevScale -= .15;
      $(elem).css('transform', `scale(${prevScale})`);
    }
  });

  $nextDots.each((_, elem) => {
    if (nextScale - .15 > 0) {
      nextScale -= .15;
      $(elem).css('transform', `scale(${nextScale})`);
    }
  });
}

const getPaginationOffset = (count, currentSlide) => {
  const offset = Math.abs(count - currentSlide - DOTS_VISIBLE);
  return offset > DEFAULT_OFFSET ? offset : DEFAULT_OFFSET;
}

const handleSlideChange = (wrapper, currentSlide, e) => {

  const { index } = e.item;
  const direction = index > currentSlide.get() ? true : false;
  const moveItems = Math.abs(currentSlide.get() - index);

  const $activeDot = $(wrapper).find('.owl-dot.active');

  const $prevDots = $activeDot.prevAll();
  const $nextDots = $activeDot.nextAll();
  const prevCount = $prevDots.length;
  const nextCount = $nextDots.length;
  const allCount = $(wrapper).find('.owl-dot').length;

  resizeDots($prevDots, $nextDots);
  if (prevCount > 1 && nextCount > 1) {
    if (currentSlide.get() < DEFAULT_OFFSET) {
      const i = DEFAULT_OFFSET - currentSlide.get();
      moveDots(moveItems - i, direction, wrapper);
    } else if (currentSlide.get() > allCount - DEFAULT_OFFSET - 1) {
      const i = Math.abs(allCount - currentSlide.get() - DEFAULT_OFFSET - 1);
      moveDots(moveItems - i, direction, wrapper);
    } else {
      moveDots(moveItems, direction, wrapper);
    }
  } else {
    if (currentSlide.get() > DEFAULT_OFFSET && currentSlide.get() < allCount - DEFAULT_OFFSET || moveItems >= allCount - DEFAULT_OFFSET) {
      const itemsToEnd = direction ? Math.abs(allCount - currentSlide.get() - moveItems - 1) : currentSlide.get() - moveItems;
      const i = moveItems + itemsToEnd - getPaginationOffset(allCount, currentSlide.get());
      moveDots(i, direction, wrapper);
    }
  }

  currentSlide.set(index);
  $activeDot.css('transform', `scale(1)`);
};

const initCarousel = (wrapper, currentSlide) => {
  carousel = $(wrapper).find('.owl-carousel');

  carousel.on('initialize.owl.carousel', (e) => {
    setTimeout(() => {
      const $dots = $(wrapper).find('.custom-dots__inner').find('.owl-dot');
      let scale = 1;
      $dots.each((_, elem) => {
        if (scale - .15 > 0) {
          scale -= .15;
          $(elem).css('transform', `scale(${scale})`);
        }
      });
    }, 100)
  });

  carousel.owlCarousel({
    loop: false,
    nav: false,
    dots: true,
    dotsEach: 1,
    dotsContainer: $(wrapper).find('.custom-dots__inner'),
    margin: 30,
    center: false,
    responsive: {
      0: {
        items: 2,
      },
      480: {
        items: 3,
      },
      600: {
        items: 4,
      },
      1000: {
        items: 5,
      },
      1200: {
        items: 6,
      }
    }
  });

  carousel.on('changed.owl.carousel', handleSlideChange.bind(null, wrapper, currentSlide));
};

export const initCustomDots = (wrapper) => {
  /** костылирование для Alfaleads.eu */
  if ($('.clients').hasClass('client-fw')) {

    if ($(window).width() > 700) return;

    $('.clients-carousel').owlCarousel({
      loop: false,
      nav: false,
      dots: false,
      margin: 30,
      center: false,
      responsive: {
        0: {
          items: 2,
        },
        480: {
          items: 3,
        },
        600: {
          items: 4,
        },
        1000: {
          items: 5,
        },
        1200: {
          items: 6,
        }
      }
    });

    return;
  }

  const currentSlide = initCurrentSlide();
  initCarousel(wrapper, currentSlide);
};
